import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import base from '../base';
import {
  ListGroup,
  ListGroupItem,
  Grid,
  Col,
  Row,
  Panel,
  Button,
  Tabs,
  Tab,
  FormGroup,
  ControlLabel,
  FormControl,
  Glyphicon
} from 'react-bootstrap';

class Exercises extends Component {
  constructor(props) {
    super(props);

    this.renderDetails = this.renderDetails.bind(this);
    this.renderExerciseListItem = this.renderExerciseListItem.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.createExercise = this.createExercise.bind(this);

    this.exerciseNode = `exercises/${this.props.uid}`;

    this.progressKey = 1;
    this.statisticsKey = 2;
    this.settingsKey = 3;

    this.state = {
      exercises: {},
      detailKey: "",
      tabKey: this.progressKey
    };
  }

  componentDidMount() {
    this.exercisesRef = base.syncState(this.exerciseNode, {
      context: this,
      state: 'exercises'
    });
  }

  componentWillUnMount() {
    base.removeBinding(this.exercisesRef);
  }

  handleClick(exercise) {
    this.setState({
      detailKey: exercise.key
    });
  }

  handleTabClick(tabKey) {
    this.setState({tabKey})
  }

  handleDelete(exercise) {
    const exercises = {...this.state.exercises};
    exercises[exercise.key] = null;
    this.setState({
      exercises: exercises,
      detail: null
    });
  }

  handleNameChange(event) {
    const exercises = {...this.state.exercises};
    const exercise = exercises[this.state.detailKey];
    exercise.name = event.target.value;
    this.setState({
      exercises: exercises,
      detail: exercise
    });
  }

  createExercise() {
    const exercise = {
      name: "New exercise...",
      key: "This key will be overwritten"
    };

    base.push(this.exerciseNode, {
      data: exercise
    }).then(newLocation => {
      exercise.key = newLocation.key;
      base.update(`${this.exerciseNode}/${exercise.key}`, {
        data: {key: newLocation.key}
      }).then(() => {
          ReactDOM.findDOMNode(this.exerciseNameFormControl).focus();
          this.setState({
            detail: exercise,
            tabKey: this.settingsKey
          });
        }).catch(err => {

        });
    }).catch(err => {
      console.log(err);
    });
  }

  renderExerciseListItem(key) {
    const exercise = this.state.exercises[key];
    const active = this.state.detailKey === key;
    return (
      <ListGroupItem 
        key={exercise.key}
        onClick={() => this.handleClick(exercise)}
        href="#"
        active={active}
      >
        {exercise.name}
      </ListGroupItem>
    );
  }

  renderDetails() {
    const keyToRender = this.state.detailKey || Object.keys(this.state.exercises)[0];
    const exercise = this.state.exercises[keyToRender];

    if (!exercise) {
      // I should instead show a create exercise pane
      return null;
    }

    const header = <div>{exercise.name}</div>;

    const deleteExercise = (
      <span>
        <strong>Delete this exercise</strong>
        <Button 
          bsStyle="danger" 
          className="pull-right"
          onClick={() => this.handleDelete(exercise)}>Delete</Button>
      </span>
    );

    return(
      <Panel header={header} bsStyle="primary">
        <Tabs activeKey={this.state.tabKey} onSelect={this.handleTabClick} id="options">
          <Tab eventKey={this.progressKey} title="Progress"><br />Add progress chart here</Tab>
          <Tab eventKey={this.statisticsKey} title="Statistics"><br />Add statistics here</Tab>
          <Tab eventKey={this.settingsKey} title="Settings">
            <br />
            <Panel header="Exercise Details">
              <FormGroup controlId="exerciseDetails">
                <ControlLabel>Exercise name</ControlLabel>
                <FormControl
                  type="text"
                  value={exercise.name}
                  placeholder="Enter name"
                  onChange={this.handleNameChange}
                  ref={(control) => this.exerciseNameFormControl = control}
                />
              </FormGroup>
            </Panel>
            <Panel header="Danger Zone" bsStyle="danger">
              <ListGroup fill>
                <ListGroupItem header={deleteExercise}>
                  Once you delete this exercise, there is no going back. Please be certain.
                </ListGroupItem>
              </ListGroup>
            </Panel>
          </Tab>
        </Tabs>
      </Panel>
    );
  }

  render() {
    const { exercises } = this.state;
    const exerciseListItems = Object.keys(exercises).map(key => this.renderExerciseListItem(key));
    
    const style = {
      marginTop: "-4px",
      marginRight: "-9px"
    };

    const header = (
      <div>
        <Button 
          style={style}
          className="pull-right" 
          bsSize="sm"
          bsStyle="primary"
          onClick={this.createExercise}
        >
          <Glyphicon glyph="plus-sign" /> New
        </Button>
        Exercises
      </div>
    );

    return(
      <div>
        <Grid>
          <Row>
            <Col md={9} mdPush={3}>
              {this.renderDetails()}
            </Col>
            <Col md={3} mdPull={9}>
              <Panel header={header} >
              <ListGroup fill>
                { exerciseListItems }
              </ListGroup>
              </Panel>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

Exercises.propTypes = {
  uid: React.PropTypes.string.isRequired
}

export default Exercises;


// WEBPACK FOOTER //
// ./src/components/Exercises.jsx